import { Link } from "eddev/routing"
import { ProjectTileFragment } from "../../types.graphql"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { Chip } from "@components/atoms/Chip"
import { Appear } from "@components/motion/Appear"
import { Button } from "@components/atoms/Button"
import { cn } from "@utils/tw"

export const ProjectTile = ({ project, type }: { project: ProjectTileFragment; type?: "big" | "small" | "medium" }) => {
  return (
    <Appear className={cn("flex flex-col gap-7", type === "big" && "md:col-span-2")}>
      <Link href={project.uri} className="flex flex-col gap-5 group">
        <div
          className={cn(
            "w-full aspect-[608/405] bg-grey-light relative overflow-hidden",
            type === "big" && "md:aspect-[692/280]",
            type === "small" && "md:aspect-[340/212]",
            type === "medium" && "md:aspect-[340/340]",
          )}
        >
          {!project.projectHeader?.featuredVideo?.mediaItemUrl &&
            project.projectHeader?.featuredImage?.mediaItemUrl && (
              <ResponsiveImage
                {...project.projectHeader.featuredImage}
                className="absolute w-full h-full md:group-hover:scale-105 transition-transform duration-500"
                objectFit="cover"
              />
            )}
          {project.projectHeader?.featuredVideo?.mediaItemUrl && (
            <video
              className="absolute w-full h-full object-cover md:group-hover:scale-105 transition-transform duration-500"
              playsInline
              autoPlay
              muted
              loop
            >
              <source src={project.projectHeader.featuredVideo.mediaItemUrl} type="video/mp4" />
            </video>
          )}
        </div>
        <div className="flex flex-col gap-0">
          <p className="type-mobile-headings-heading-s md:type-desktop-headings-heading-s leading-none">
            {project.title}
          </p>
          <p className="type-mobile-headings-heading-s md:type-desktop-headings-heading-s text-concrete leading-none">
            {project.projectHeader?.location?.[0]?.name || <span dangerouslySetInnerHTML={{ __html: "&nbsp;" }} />}
          </p>
        </div>
      </Link>
      {/* <Button href={project.uri!}>View Project</Button> */}
    </Appear>
  )
}
